<template>
  <b-row class="px-2 mt-3">
    <b-col>
      <div class="iq-card">
        <div class="iq-card-header d-flex justify-content-between">
          <div class="iq-header-title">
            <h5 class="card-title">RPM, Fuel Consumption, And Speed Chart</h5>
          </div>
        </div>
        <div class="card-info-container" :class="{ 'card-info-container--center-avg': infoSections.length === 1 }">
          <div class="card-info-section" v-for="section in infoSections" :key="section.key">
            <h5 class="">{{ section.value }}</h5>
            <span class="">{{ section.label }}</span>
          </div>
        </div>

        <rpm-fuel-speed
          class="mx-3 mb-3"
          :series="currAssetSummary.series"
          :deviceStatus="deviceStatus"
        />
      </div>
    </b-col>
  </b-row>
</template>

<script>
import RpmFuelSpeed from '@/components/charts/RpmFuelSpeed';
import { getRpmTypeLabel } from '@/util/fms-summary';

export default {
  name: 'RpmFuelSpeedCard',
  components: {
    RpmFuelSpeed,
  },
  props: {
    currAssetSummary: {
      type: Object,
      required: true,
    },
    deviceStatus: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  computed: {
    infoSections() {
      const sections = [];
      const { fm, rpm, gps } = this.currAssetSummary || {};
      const rpmTypes = this.deviceStatus?.rpmTypes || [];
      if (!fm || !rpm || !gps) return [];

      if (fm.PORT?.in && rpm.port) {
        const displayLabel = getRpmTypeLabel('PORT', rpmTypes);
        sections.push({ key: 'port-rpm', label: `Avg. ${displayLabel} RPM`, value: rpm.port.average });
        sections.push({ key: 'port-fm', label: `${displayLabel} Fuel Cons`, value: `${fm.PORT.in.engineCons} Liter` });
      }
      if (fm.STARBOARD?.in && rpm.starboard) {
        const displayLabel = getRpmTypeLabel('STARBOARD', rpmTypes);
        sections.push({ key: 'starboard-rpm', label: `Avg. ${displayLabel} RPM`, value: rpm.starboard.average });
        sections.push({ key: 'starboard-fm', label: `${displayLabel} Fuel Cons`, value: `${fm.STARBOARD.in.engineCons} Liter` });
      }
      if (fm.CENTER?.in && rpm.center) {
        const displayLabel = getRpmTypeLabel('CENTER', rpmTypes);
        sections.push({ key: 'center-rpm', label: `Avg. ${displayLabel} RPM`, value: rpm.center.average });
        sections.push({ key: 'center-fm', label: `${displayLabel} Fuel Cons`, value: `${fm.CENTER.in.engineCons} Liter` });
      }

      sections.push({ key: 'avg-speed', label: 'Avg. Speed', value: `${gps.averageSpeed} Knot` });

      return sections;
    },
  },
};
</script>

<style scoped>
.card-info-container {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 10px;
  padding: 10px 15px;
}

.card-info-container--single {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.card-info-container--center-avg {
  grid-template-columns: 1fr;
  justify-items: center;
}

.card-info-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

@media screen and (max-width: 991px) {
  .card-info-container {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    grid-template-rows: auto auto;
  }
}
</style>
